import { Button } from '@cambridgeassessment/cambridge-ui/build/components/Button';
import { Box, Container } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import React, { memo, useCallback, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import useOrgUsers from '../../../hooks/useOrgUsers';
import SearchField from '../../SearchField/SearchField';
import UsersTable from '../../UsersTable/UsersTable';
import routes from '../routes';
import { useStylesUsersPage } from '../styles';

interface OrgUsersProps {
  orgId: string;
}

const OrgUsers: React.FC<OrgUsersProps> = ({ orgId }) => {
  const classes = useStylesUsersPage();
  const {
    isLoading,
    users,
    error,
    userTableSettings,
    searchQuery,
    updateSearchQuery,
    updateUserTableSettings,
  } = useOrgUsers();

  const history = useHistory();
  const { associateId } = useParams();

  const handleAddUser = useCallback(() => {
    if (associateId) {
      history.push(`/organisation/associate/child/${associateId}/users/add`);
    } else {
      history.push(routes.AddUser.path);
    }
  }, [associateId]);

  useEffect(() => updateSearchQuery(''), []);

  return (
    <Container disableGutters maxWidth="xl">
      <Box
        display="flex"
        justifyContent={['unset', 'space-between']}
        flexDirection={['column', 'row']}
        alignItems={['flex-end', 'unset']}
      >
        <Box className={classes.searchField}>
          <SearchField
            searchQuery={searchQuery}
            placeholder="Search for a user"
            onSubmit={updateSearchQuery}
            onChange={updateSearchQuery}
          />
        </Box>
        <Box className={classes.button}>
          <Button
            component={Link}
            onClick={handleAddUser}
            size="large"
            startIcon={<Add />}
            variant="contained"
            data-testid="addUsers"
            style={{
              textTransform: 'none',
            }}
          >
            Add user(s)
          </Button>
        </Box>
      </Box>
      <Box className={classes.table}>
        <UsersTable
          isLoading={isLoading}
          users={users}
          searchQuery={searchQuery}
          error={error}
          userTableSettings={userTableSettings}
          updateUserTableSettings={updateUserTableSettings}
        />
      </Box>
    </Container>
  );
};

export default memo(OrgUsers);
